import { HeaderData } from './SessionReport.styled';
import { getData } from './utils';

const DataElem = ({ report, attr, objkey, text = null, format = (e) => e, sx = {} }) => (
    <HeaderData sx={sx}>{format(text !== null ? text : getData(report, attr, objkey))}</HeaderData>
);

export default DataElem;